<template>
  <div class="container">
    <div class="how-it-work">
      <p>How Does It Work?</p>
      <div class="startnow">
        <router-link :to="{ name: 'FetchOrder' }"
          ><button>Start Immediately!</button>
        </router-link>
      </div>
    </div>
    <div class="box">
      <h2>Step 1</h2>
      <img
        src="../assets/BecomeSaviour/order-icon.webp"
        alt="Order Icon"
        width="100px"
        height="100px"
      />
      <p>
        <b>Customers Order Their Food</b>
      </p>
    </div>
    <div class="box">
      <h2>Step 2</h2>
      <img
        src="../assets/BecomeSaviour/accept.png"
        alt="Accept Order"
        width="100px"
        height="100px"
      />
      <p><b>Accept The Order Available Near Your Location</b></p>
    </div>
    <div class="box">
      <h2>Step 3</h2>
      <img
        src="../assets/BecomeSaviour/takefood.png"
        alt="Take the Food Icon"
        width="100px"
        height="100px"
      />
      <p>
        <b
          >Go To The Restaurant In Time And Place The Order On Behalf <br />
          Of The Customer And Pick It Up</b
        >
      </p>
    </div>
    <div class="box">
      <h2>Step 4</h2>
      <img
        src="../assets/BecomeSaviour/deliver2.webp"
        alt="Deliver Icon"
        width="100px"
        height="100px"
      />
      <p>
        <b
          >Deliver The Order To The Customer In Time, According To The
          <br />Location Shown In The App And Get Your Reward!</b
        >
      </p>
    </div>

    <div class="startnow">
      <router-link :to="{ name: 'FetchOrder' }"
        ><button>Start Now!</button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Saviour",
};
</script>

<style lang="scss" scoped>
// .container {
//   margin: auto;
//   display: flex;
//   bottom:20px;
// }

h1 {
  text-align: center;
}

.box {
  p {
    font-size: 20px;
    text-align: center;
  }

  img {
    position: inherit;
  }

  p {
    position: inherit;
    bottom: 0px;
  }

  position: relative;
  width: max;
  min-height: 250px;

  @media (min-width: 800px) {
    min-height: 200px;
  }

  background: yellow;
  margin: 15px;
  // float: left;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 10px;
  padding: 15px;
}

p {
  margin-top: 20px;
  text-align: center;
  font-size: 40px;
}

button {
  width: 100%;
  height: 55px;
  border-radius: 30px;
  color: white;
  background-color: #000;
  transition: 0.25s;
  font-size: 16px;
  margin-top: 15px;

  &:hover {
    background-color: rgb(50, 50, 50);
    transition: 0.25s;
  }
}

.startnow {
  margin: 15px;
  justify-content: center;
  align-content: center;
}

/*
.saviour {
  p {
    margin-top: 20px;
    text-align: center;
    font-size: 40px;
  }
}
*/
</style>
